import type { ApolloQueryResult } from "@apollo/client";
import gql from "graphql-tag";
import { defineStore } from "pinia";

import {
  BRANDS_FILTER_QUERY,
  BRANDS_QUERY,
  GET_BRAND_BY_ID,
  UPDATE_BRAND,
} from "@/api/brand.ts";
import { apollo } from "@/utils/apollo.ts";

interface State {
  all: any[]
  selected: any | null
}

export const useBrandsStore = defineStore("brands", {
  state: (): State => ({
    all: [],
    selected: null,
  }),
  getters: {
    getBrands({ all }) {
      return all;
    },
  },
  actions: {
    setBrands(brands: any[] = []) {
      this.all = brands;
    },
    async fetch(params = {}) {
      try {
        const { data }: any = await apollo.query<{
          brands: {
            id: any
            brand_name: string
            short_name: string
          }[]
        }>({
          query: BRANDS_FILTER_QUERY,
          variables: {
            ...params,
            limit: 100,
            isActive: true,
          },
        });

        this.all = data.brands?.data?.map((brand: any) => ({
          ...brand,
          label: brand.brand_name,
        }));
      }
      catch (e) {
        console.log(e);
      }
    },
    async fetchBrands(params = {}) {
      return await apollo.query({
        query: gql`
          query brands(
            $page: Int
            $limit: Int
            $isActive: Boolean
            $search: String
          ) {
            brands(
              page: $page
              limit: $limit
              isActive: $isActive
              search: $search
            ) {
              data {
                id
                brand_name
                short_name
                created_at
                is_active
                tier
                shipping_destination
                brand_groups {
                  parent_brand_name
                  short_name
                }
              }
              total
              perPage
              current
              from
              to
              previous
              next
            }
          }
        `,
        variables: params,
      });
    },
    fetchAll(params = {}): Promise<ApolloQueryResult<any>> {
      return new Promise((resolve, reject) => {
        apollo
          .query({
            query: BRANDS_QUERY,
            variables: {
              ...params,
            },
          })
          .then(resolve)
          .catch(reject);
      });
    },
    fetchOne(id: any) {
      return apollo.query({
        query: GET_BRAND_BY_ID,
        variables: {
          id,
        },
      });
    },
    update(id: any, response: { mpt_id: any }) {
      return apollo.mutate({
        mutation: UPDATE_BRAND,
        variables: {
          id,
          data: response,
        },
      });
    },
  },
});
